import { Modal, ModalProps } from 'antd'
import styles from './AModal.module.less'
import cls from 'classnames'
import AButton, { AButtonProps } from '../AButton/AButton'
import { useTranslation } from 'react-i18next'

export type FooterBtnCommonProps = Pick<AButtonProps, 'size' | 'type' | 'disabled'> & {
  text: string
}

type Props = Omit<ModalProps, 'okButtonProps' | 'cancelButtonProps'> & {
  testId?: string
  onConfirm?: () => void
  onCancel?: () => void
  confirmText?: string
  cancelText?: string
  confirmBtnProps?: FooterBtnCommonProps
  cancelBtnProps?: FooterBtnCommonProps
}

const COMPONENT_NAME = 'A-Modal'
function AModal(props: Props) {
  const { i18n } = useTranslation()
  const { testId, className, footer, children, ...modalProps } = props
  const hasDefaultFooter =
    props.confirmText ||
    props.cancelText ||
    props.onConfirm ||
    props.confirmBtnProps ||
    props.cancelBtnProps
  const modalFooter = footer !== undefined ? footer : hasDefaultFooter ? <ModalFooter {...props} /> : null

  return (
    <Modal
      {...modalProps}
      data-testid={testId}
      maskClosable={false}
      className={cls(styles[COMPONENT_NAME], styles[i18n.language], className)}
      centered
      // transitionName='ant-fade'
      footer={modalFooter}
    >
      {children}
    </Modal>
  )
}

interface ModalFooterProps {
  testId?: string
  confirmText?: string
  cancelText?: string
  onConfirm?: () => void
  onCancel?: () => void
  confirmBtnProps?: FooterBtnCommonProps
  cancelBtnProps?: FooterBtnCommonProps
}

function ModalFooter(props: ModalFooterProps) {
  const {
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    onConfirm,
    onCancel,
    confirmBtnProps,
    cancelBtnProps,
  } = props
  return (
    <div className={styles['A-Modal-footer']}>
      <AButton testId={props.testId ? `${props.testId}-cancel-btn` : undefined} type='outlined' {...cancelBtnProps} onClick={onCancel}>
        {cancelBtnProps?.text || cancelText}
      </AButton>
      <AButton testId={props.testId ? `${props.testId}-confirm-btn` : undefined} type='primary' {...confirmBtnProps} onClick={onConfirm}>
        {confirmBtnProps?.text || confirmText}
      </AButton>
    </div>
  )
}

export default AModal
